import React from 'react';
import SwitchButton from '@/domains/traffic-monitoring/components/SwitchButton/SwitchButton';
import { cn } from '@/lib/utils';

interface CardControlProps {
  styleCard?: string;
  icon: string;
  title: string;
  total: number;
  groupKey: string;
  id: string;
}

const CardControl = ({ icon, title, total, styleCard, groupKey, id }: CardControlProps) => {
  return (
    <div
      className={cn(
        'w-full rounded-[12px] p-3 dark:bg-[#F3F6FE]/10  border shadow-[0_4px_4px_0_rgba(0,0,0,0.16)] flex flex-row justify-between items-center gap-3',
        styleCard
      )}
    >
      <div className="flex items-center gap-3">
        <img src={icon} alt={title} className="w-fit" />
        <span className="title1medium">{title}</span>
      </div>

      <div className="flex items-center gap-3">
        <span className="title1">{total}</span>

        <SwitchButton groupKey={groupKey} id={id} />
      </div>
    </div>
  );
};

export default CardControl;
